/* AURA · botón de compra → carrito de Shopify → checkout */
(function(){
  var S=window.AURA_SHOP||{}; if(!S.banda) return;
  var q=function(x){return document.querySelector(x);};
  var ocupado=false, reloj=0;
  // libera los botones: al fallar, y al volver del checkout con «atrás» (el navegador restaura la página tal cual quedó, bloqueada)
  var liberar=function(){ ocupado=false; clearTimeout(reloj); [].slice.call(document.querySelectorAll('.nb__cta,[data-barcta]')).forEach(function(b){b.removeAttribute('aria-busy');b.style.opacity='';}); };
  window.addEventListener('pageshow',liberar);
  var comprar=function(e){
    if(e){e.preventDefault();}
    if(ocupado) return; ocupado=true;
    var items=[{id:S.banda,quantity:1}];
    // correas extra: el estado real de la landing (window.AURA_ST); el DOM puede tener marcado un color oculto que no existe
    var st=window.AURA_ST, addon=q('[data-addon]');
    if(st?st.addon:(addon&&addon.getAttribute('aria-checked')==='true')){
      var mat=st?st.mat:((q('[data-mat].on')||{}).getAttribute?q('[data-mat].on').getAttribute('data-mat'):'silicona');
      var m=S.correas[mat]||{}, col=st?st.color:'', n=st?st.nc:(parseInt((q('[data-nc]')||{}).textContent||'1',10)||1);
      var v=m[col]||m[Object.keys(m)[0]];
      if(v) items.push({id:v,quantity:n});
    }
    // regalo de la promo (la página Halloween define AURA_REGALO = producto regalo a $0, hoy Tela Naranja): +1 a lo que haya elegido
    var R=window.AURA_REGALO;
    if(R){ var ya=items.filter(function(it){return it.id===R;})[0]; if(ya) ya.quantity+=1; else items.push({id:R,quantity:1}); }
    var botones=[].slice.call(document.querySelectorAll('.nb__cta,[data-barcta]'));
    botones.forEach(function(b){b.setAttribute('aria-busy','true');b.style.opacity='.7';});
    reloj=setTimeout(liberar,10000);   // por si la redirección nunca ocurre
    // /cart/update.js FIJA las cantidades (1 banda + las correas elegidas): si vuelve del checkout y toca de nuevo, no se duplica el pedido
    var updates={}; items.forEach(function(it){ updates[it.id]=it.quantity; });
    fetch('/cart/update.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({updates:updates})})
      .then(function(r){ if(!r.ok) throw new Error('cart'); return r.json(); })
      .then(function(){ window.location.href=window.AURA_CUPON?('/discount/'+encodeURIComponent(window.AURA_CUPON)+'?redirect=%2Fcheckout'):'/checkout'; })
      .catch(function(){ liberar(); alert('No pudimos agregar tu pedido. Probá de nuevo en un momento.'); });
  };
  var bind=function(){ [].slice.call(document.querySelectorAll('.nb__cta,[data-barcta]')).forEach(function(b){ b.addEventListener('click',comprar); }); };
  document.readyState!=='loading'?bind():document.addEventListener('DOMContentLoaded',bind);
})();
